import BaseModel from '@/models/list/base';

export default class LevelDocument extends BaseModel {
  constructor(document, url) {
    super(document, url);

    this.levels = document.levels || [];
    this.organizer_id = document.organizer_id;
    this.title = document.title; // nullable|string|max:500
    this.show_after_at = document.show_after_at;
    this.show_before_at = document.show_before_at;
    this.initiate_event_id = document.initiate_event_id || null;
    this.root_event_id = document.root_event_id || null;

    // expands
    this.images = document.images || [];
    this.documents = document.documents || [];
    this.organizer = document.organizer || null;
    this.initiate_event = document.initiate_event || null;
    this.root_event = document.root_event || null;
  }
}
